import ExtrudeModel from './extrude';
import FillModel from './fill';
import IconModel from './icon-font';
import IMageModel from './image';
import NormalModel from './normal';
import TextModel from './text';
var PointModels = {
  fill: FillModel,
  image: IMageModel,
  normal: NormalModel,
  extrude: ExtrudeModel,
  text: TextModel,
  icon: IconModel
};
export default PointModels;
//# sourceMappingURL=index.js.map